export default __webpack_public_path__ + "static/media/28.1cf5ac6d.jpg";